import React from 'react';
import { cn } from '../index';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, ...props }, ref) => (
    <div className="w-full">
      <textarea
        ref={ref}
        className={cn(
          'flex min-h-[80px] w-full rounded-lg border px-3 py-2 text-sm transition-colors resize-y',
          'bg-[var(--input)] border-[var(--input-border)] text-[var(--fg)]',
          'placeholder:text-[var(--input-placeholder)]',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)] focus-visible:border-transparent',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          error && 'border-[var(--destructive)] focus-visible:ring-[var(--destructive)]',
          className,
        )}
        {...props}
      />
      {error && <p className="mt-1 text-xs text-[var(--destructive)]">{error}</p>}
    </div>
  ),
);
Textarea.displayName = 'Textarea';
